module.exports = __webpack_public_path__ + "img/advisor-img6.00dad328.jpg";